/* eslint-disable react/no-unescaped-entities */
import React from "react";
import "./styles.css";

export default function Terms() {
  return (
    <div className="Terms">
      <div>
        <p>
          <span>NOTIX Service License Agreement (the "Agreement")</span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <span>
            Samoukale Enterprises Limited (the, "NOTIX", "We", etc.) being a
            company offering services that enable, through a license, Users
            globally to add NOTIX Script within their Source(s) and/or to use
            other NOTIX related web services and features in order to send,
            optimize and manage Push Notifications to their end users (the
            "Service"), and
          </span>
        </p>
        <p>
          <span>
            You (the, "User", "You", "Yours", etc.) being the
            owner/administrator/controlling person of a Source, having
            sufficient authority to enter into present Agreement, wishing to
            send, optimize and manage Push Notifications to your end users
            through the Service,{" "}
          </span>
        </p>
        <p>
          <span>NOTIX and User hereby agree as follows:</span>
        </p>
        <p>
          <span>
            BY CHECKING THE BOX AND CLICKING "I ACCEPT" BUTTON, AS APPLICABLE,
            OR BY CONTINUING TO PARTICIPATE IN THE SERVICE FOLLOWING OUR
            PUBLICATION OF THE REVISED VERSION OF THIS AGREEMENT ON OUR WEBSITE,
            YOU (A) CONFIRM THAT YOU ARE AWARE AND COMPLY WITH PRESENT AGREEMENT
            AND AGREE TO BE BOUND BY THIS AGREEMENT; (B) ACKNOWLEDGE AND AGREE
            THAT YOU HAVE INDEPENDENTLY EVALUATED THE DESIRABILITY OF
            PARTICIPATING IN THE PROGRAM/SERVICE AND ARE NOT RELYING ON ANY
            REPRESENTATION, GUARANTEE, OR STATEMENT OTHER THAN AS EXPRESSLY SET
            FORTH IN THIS AGREEMENT; (C) HEREBY REPRESENT AND WARRANT THAT YOU
            ARE AUTHORIZED AND LAWFULLY ABLE TO ENTER INTO THIS AGREEMENT AND
            THAT YOU ARE AND WILL REMAIN IN COMPLIANCE WITH THIS AGREEMENT; AND
            (D) AGREE TO RECEIVE DIRECTLY TO YOUR E-MAIL NEWSLETTERS, LATEST
            PROMOTIONS, CASE-STUDIES AND TUTORIALS FROM US.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>1. Definitions</strong>
        </p>
        <p>
          <span>
            1.1. "User" – means a party that has decided to enter into this
            Agreement and to assign NOTIX to provide the Service in accordance
            with the terms and conditions of this Agreement.
          </span>
        </p>
        <p>
          <span>
            1.2. "User Account" / "Account" – means the User's account at NOTIX
            web-site <a href="http://www.notix.co"> www.notix.co</a> .
          </span>
        </p>
        <p>
          <span>
            1.3. "Content" – means textual, visual, or aural content that is
            encountered as part of the User's Source(s). It may include
            documents, data, applications, e-services, images, audio and video
            files, personal web pages, archived e-mail messages, and etc.
          </span>
        </p>
        <p>
          <span>
            1.4. "Source(s)" – means/includes/represents/refers to any and/or
            all domain names/websites/applications/sites/landing pages/links of
            the User provided to NOTIX for the provision of the Service under
            the terms of this Agreement. The most suitable/appropriate
            interpretation being/to be adopted depending on each case and at the
            discretion of NOTIX if such interpretation is questionable/in
            dispute.
          </span>
        </p>
        <p>
          <span>
            1.5. "Script" - means a technical solution provided by NOTIX to the
            User, enabling the User to collect Push Notification subscribers and
            to reach them with Push Notifications.
          </span>
        </p>
        <p>
          <span>
            1.6. "Push Notification(s)" – means web/mobile push notification
            created, sent, optimized and managed by the User through NOTIX and
            the provision of the Service.
          </span>
        </p>
        <p>
          <span>
            1.7. "Effective Date" – means the date of adoption of the terms of
            this Agreement by the User or in the absence of its signature, the
            date when the User set up a User Account with NOTIX.
          </span>
        </p>
        <p>
          <span>
            1.8. "NOTIX Platform" – means a platform as a service (PaaS)
            offering the Service to the User, available at{" "}
            <a href="http://www.notix.co"> www.notix.co</a> .
          </span>
        </p>
        <p>
          <span>
            1.9. "Confidential Information" – will include any information,
            whether provided in writing, orally, visually, electronically or by
            other means, related to the Service(s) and/or business of a party
            and is treated as confidential or secret by the party, including but
            not limited to (i) all information marked as "Confidential,"
            "Proprietary," or similar legend by the disclosing party
            ("Discloser") when given to the receiving party ("Recipient"); and
            (ii) information and data provided by the Discloser, which under the
            circumstances surrounding the disclosure should be reasonably deemed
            confidential or proprietary.
          </span>
        </p>
        <p>
          <span>
            1.10. "Active Subscribers" – all subscribed users available in the
            User's account excluding all unsubscribed users.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>2. The Service</strong>
        </p>
        <p>
          <span>
            2.1. In order to become a User, you must first accurately submit an
            application for NOTIX User account at our website and be in
            compliance with present Agreement (in case of using Self-service) or
            register as a User by contacting NOTIX directly (in case you wish to
            use dedicated campaign Management service) for acceptance, and not
            use any aliases or other means to mask your true identity or contact
            information. After we review your application, we will notify you of
            your acceptance or rejection as NOTIX's User. We may accept or
            reject your account registration at any time at our sole discretion
            for any reason. NOTIX reserves the right to add, edit, remove or
            reclaim any account details (including your submissions) with or
            without your consent if deemed appropriate at NOTIX's sole
            discretion.
          </span>
        </p>
        <p>
          <span>
            2.2. By filing your account application or registering as a User you
            confirm your understanding and unreserved acceptance of present
            Agreement and other terms and conditions of NOTIX, including, but
            not limited to the Privacy Policy, published at our website
            concerning the Program, and confirm that you are a duly authorized
            signatory, have full legal capacity and all the necessary authority
            to bind the individual, company or other entity, and hereby
            submitting a legally binding electronic signature and entering into
            a legally binding contract.
          </span>
        </p>
        <p>
          <span>
            2.3. After going through the registration process, every User of
            NOTIX Service becomes a User of the Free Plan provided by the
            Service.  When a User reaches the amount of thirty thousand (30,000)
            and more active subscribers in his/her/its account then the User
            must provide payment based on the amount of active subscribers in
            his/her/its account and according to the pricing plans available for
            the User by NOTIX.  In any case the User is obligated but fails for
            any reason to pay according to the pricing plans then the Service
            provided to the User by NOTIX will be immediately stopped and/or
            withdrawn and/or discontinued. NOTIX Service is to be provided for
            free of charge if the User selects NOTIX Monetization Plan.
          </span>
        </p>
        <p>
          <span>
            2.4. In order to be eligible to become a NOTIX's User, any and/or
            all of your Sources shall meet the following criteria:
          </span>
        </p>
        <ul>
          <li>
            <span>
              Be fully functional at all levels; no "under construction"
              sites/links or sections; and
            </span>
          </li>
          <li>
            <span>Shall comply with the applicable legislation.</span>
          </li>
        </ul>
        <p>
          <span>
            For the first criteria described above, exceptions may apply at the
            sole discretion of NOTIX, in the sense that some Sources without
            content and/or sites/links or sections "under construction" may be
            accepted/verified by NOTIX only at its own will and when it
            considers it appropriate.
          </span>
        </p>
        <p>
          <span>
            2.5. The User must provide NOTIX with all Sources wished to be used
            during the provision of the services before the placement of any
            Script/ad tech in Source(s) of the User, for verification purposes.
             At all times, the User must notify NOTIX for any new Source(s)
            before proceeding with any Script/ad tech placement.  
          </span>
        </p>
        <p>
          <span>
            2.5.a At all times User must notify NOTIX for any actual and/or
            intentional
            change/modification/alteration/distortion/termination/elimination of
            any and/or all already verified Source(s) and for any action that
            may/will remove access of NOTIX to the subscribers of the User
            and/or that may/will provide false/wrong/corrupted
            information/number of subscribers and/or render the Service under
            this Agreement impossible.
          </span>
        </p>
        <p>
          <span>
            User shall notify NOTIX at least forty eight (48) hours before such
            actual and/or intentional
            change/modification/alteration/distortion/termination/elimination
            and action takes place.
          </span>
        </p>
        <p>
          <span>
            2.5.b. In any case and at any time the User fails to inform NOTIX as
            required and/or NOTIX identifies its Scripts/ad techs in a Source
            whose domain name has not been notified by the User and verified by
            NOTIX, then User understands and agrees that NOTIX has no
            responsibility whatsoever and/or no responsibility in relation to
            the Source and/or for the failure of the User to notify, nor any
            kind of control over the Source and that NOTIX cannot and will not
            review/verify/approve such Source and/or confirm whether such Source
            meets the conditions of this Agreement. The User accepts all
            responsibility raised or that may be raised at any time under clause
            2.5. and confirms that he/it is the sole responsible person/legal
            person to ensure that such Source(s) meets the requirements and is
            in accordance with the terms of this Agreement.  
          </span>
        </p>
        <p>
          <span>
            2.6. User understands and accepts that NOTIX does not allow and
            prohibits the multiple account opening for each User. User agrees
            not to fill in an account application and/or register as a User more
            than one time and/or hold more than one account with NOTIX for any
            reason and/or in order to benefit in any way from any marketing
            promotional program/project and/or offer available for the User by
            NOTIX.
          </span>
        </p>
        <p>
          <span>
            In any case where NOTIX identifies multiple account
            applications/registrations/openings/holdings of a User through the
            use of any technology or through other means available for and/or
            acceptable by NOTIX  only, NOTIX  may forbid access to and/or
            suspend and/or ban and/or close any such multi accounts and/or the
            main account of the User and/or manage all accounts in such way
            and/or take any other actions and measures deemed appropriate in the
            sole discretion of NOTIX , regardless of the reason/purpose that
            such multi account applications/registrations/openings/holdings were
            created.
          </span>
        </p>
        <p>
          <span>
            If the only and/or any account of the User is forbidden access to
            and/or is suspended and/or banned and/or closed for any reason,
            including but not limited for reasons related to prohibited/non
            accepted activity, the User understands and agrees that is not
            allowed and will not fill in another account application and/or
            re-register and/or create and/or hold any other new account for the
            same reason and/or for any other prohibited/non accepted activity.  
          </span>
        </p>
        <p>
          <span>
            2.7. NOTIX may allow multi account
            applications/registrations/openings/holdings for a User if this is
            specifically and clearly predefined as accepted/permitted in any
            specific marketing promotional program/project and/or offer and/or
            in exceptional cases, at any time and for any reason NOTIX considers
            acceptable and solely at its own discretion, if the User submits
            such request by sending an email to support@notix.co.
          </span>
        </p>
        <p>
          <span>
            2.8. The content of the User's Source(s) or its affiliated
            Source(s), as also the User's Push Notifications, must not include
            and/or relate to/promote any material that infringes the rights of
            any third party or that is in violation of any law, as bound by the
            law itself or as determined by us in our sole discretion, including
            but not limited to the following:
          </span>
        </p>
        <ul>
          <li>
            <span>Pornography, adult or mature content;</span>
          </li>
          <li>
            <span>
              Illegal activity and/or promotion of illegal activity (i.e.
              illegal online gambling, how to build a bomb, counterfeiting
              money, hacking, phreaking, etc.);
            </span>
          </li>
          <li>
            <span>
              Hate-mongering (i.e. racial, political, ethnic, religious,
              gender-based, sexuality-based or personal, etc.) or otherwise
              objectionable content;
            </span>
          </li>
          <li>
            <span>
              Violence (including gratuitous violence), profanity, obscene or
              vulgar language and abusive content or content which endorses or
              threatens physical harm;
            </span>
          </li>
          <li>
            <span>
              Illegal substance and/or promotion of illegal substance;
            </span>
          </li>
          <li>
            <span>Drugs or any related paraphernalia;</span>
          </li>
          <li>
            <span>Adware, malware, viruses, phishing offers;</span>
          </li>
          <li>
            <span>
              Creatives should not contain misleading, deceptive, abusive,
              intolerant, defamatory, provocative and\or false information
              and\or materials to the user;
            </span>
          </li>
          <li>
            <span>Purchase of weapons/military equipment;</span>
          </li>
          <li>
            <span>False or deceptive investment advice, and others;</span>
          </li>
          <li>
            <span>
              Intellectual property rights (brand name, trademarks, logo, etc);
            </span>
          </li>
          <li>
            <span>
              Investment, money-making opportunities or advice not permitted
              under law ("get rich fast", "Ponzi schemes" and etc.);
            </span>
          </li>
          <li>
            <span>
              Material that defames, abuses, or threatens physical harm to
              others;
            </span>
          </li>
          <li>
            <span>
              Software Pirating (e.g., Warez, P2P, Bit torrent, Hotline, etc.);
            </span>
          </li>
          <li>
            <span>Hacking or Phreaking;</span>
          </li>
          <li>
            <span>
              Fraud, unofficial, untrue, false, misleading, invented,
              re-produced information, facts, news, offers, solutions,
              guidelines related to or aiming to treat in any way and at any
              level vulnerabilities of all kind, including but not limited to
              any physical, mental, psychological, social, religious, economic,
              scientific vulnerabilities;
            </span>
          </li>
          <li>
            <span>Any illegal activity whatsoever;</span>
          </li>
          <li>
            <span>
              Any spoofing, redirecting of the end users in an effort to gain
              traffic; or
            </span>
          </li>
          <li>
            <span>
              Any other inappropriate activity as determined by us in our sole
              discretion.
            </span>
          </li>
        </ul>
        <p>
          <span>
            User must not use the Service in connection with any of the above,
            nor enable direction to another Source which is related
            to/contains/promotes such prohibited content.  
          </span>
        </p>
        <p>
          <span>
            2.9. User acknowledges and accepts that NOTIX may stop providing the
            Service in case the User's Source(s) and/or Push Notifications
            includes/directs to inappropriate content as described under this
            clause 2.
          </span>
        </p>
        <p>
          <span>
            2.10. User must notify NOTIX in writing of any changes to the
            content on User's Source(s) and/or in Push Notifications which could
            be deemed inappropriate content.
          </span>
        </p>
        <p>
          <span>
            2.11. NOTIX may, but is not obliged to, view the Source(s) and/or
            Push Notifications of the User for the presence of prohibited
            Content/Push Notification and may remove or move (without warning)
            any Content/Push Notifications or Users in its sole discretion, for
            any reason or no reason, including without limitation the movement
            or removal of Content/Push Notification that, in the personal
            opinion of NOTIX, violates this Agreement, and/or may violate the
            rights, harm or threaten the safety of other Users or third parties.
          </span>
        </p>
        <p>
          <span>
            2.12. In case where there is such prohibited content on User's
            Source(s) and/or Push Notifications, NOTIX reserves the right to
            submit an immediate legal action against the User and/or set a
            financial penalty, based on the damages caused to NOTIX. User will
            defend, indemnify and hold NOTIX or its affiliates and
            representatives harmless from any damages, liabilities, costs, and
            expenses (incl. attorneys' fees) resulting from any claim, judgment
            or proceeding brought by a third party.
          </span>
        </p>
        <p>
          <span>
            2.13. NOTIX does not check or control the activities or contents of
            your Source(s)/Affiliated Source(s)/Push Notification, but all
            Services may be rejected and we reserve the right to delete your
            account, if you engage in fraudulent or illegal activity.
          </span>
        </p>
        <p>
          <span>
            2.14. NOTIX has the following Non Acceptable Business rules for
            Users:
          </span>
        </p>
        <ul>
          <li>
            <span>
              Where there are known or perceived links to terrorist
              organisations, military, arms and/or ammunition manufacture or
              sales;
            </span>
          </li>
          <li>
            <span>
              Where there is knowledge or suspicion of money laundering or
              terrorist financing;
            </span>
          </li>
          <li>
            <span>
              Where it is known or there are reasonable grounds for suspicion
              that a criminal offence has taken place;
            </span>
          </li>
          <li>
            <span>
              Where the User or any of the Users' associated parties are subject
              to any sanctions measures;
            </span>
          </li>
          <li>
            <span>
              Where the User is undertaking an activity or trade within, from or
              into a country where that activity is subject to embargo and/or
              trade control restrictions;
            </span>
          </li>
          <li>
            <span>
              Producers/promoters of racist/pornographic/pressure group material
              or extreme political propaganda;
            </span>
          </li>
          <li>
            <span>
              Regulated entities that do not have the appropriate licensing;
            </span>
          </li>
          <li>
            <span>Extreme political and/or charitable organisations.</span>
          </li>
        </ul>
        <p>
          <span>
            2.15. User must not use any Script/tool/inventory/ information/Push
            Notification service available for him through NOTIX for and/or in
            any way that suggests and/or results to any misleading and/or
            fraudulent activity. User understands and agrees that such
            Scripts/tools/inventories/information/Push Notification services are
            only provided to the User in good faith and that NOTIX is not
            responsible and must not bear any responsibility whatsoever in
            relation to their use at any time.
          </span>
        </p>
        <p>
          <span>
            2.16. There are the following methods of using the Service available
            – Self-Service or Management service.
          </span>
        </p>
        <p>
          <span>
            Self-Service assumes that access to the Service shall be provided
            through Users' personal account. NOTIX support team may provide
            assistance upon your request, however, all the actions or
            modifications made through your account shall be deemed made solely
            by you.
          </span>
        </p>
        <p>
          <span>
            Management service assumes that assistance of using the Services and
            Program shall be provided by NOTIX officers.
          </span>
        </p>
        <p>
          <span>
            2.17. All support and/or assistance and/or service provided to User
            by NOTIX and/or NOTIX officers and/or support team and/or any other
            NOTIX personnel and/or employee is intended to be and must be
            considered by the User as mere information.  No information and/or
            support and/or assistance and/or service provided during such
            Self-Service or Management Services and/or during the Provision of
            the Services themselves shall be construed as containing, advice or
            a recommendation or an offer of or solicitation for any service
            provided, regardless of the type, kind, form, mean, way in which it
            is provided.  In addition, any past performance described is not a
            guarantee of or prediction of future performance. NOTIX does not
            take into account your personal objectives or financial situation.
            NOTIX makes no representation and assumes no liability as to the
            accuracy or completeness of the information provided, nor as to any
            loss arising from any action based on an assumed recommendation,
            forecast or other information supplied by any NOTIX officers and/or
            support team and/or any other NOTIX personnel and/or employee. All
            expressions of opinion are subject to change without notice. Any
            opinions made may be personal to the individual itself and may not
            reflect the opinions of NOTIX.  No communication whatsoever must be
            reproduced or further distributed without the prior permission of
            NOTIX.
          </span>
        </p>
        <p>
          <span>
            2.18. In order for any communication between the User and NOTIX
            and/or NOTIX officers and/or support team and/or any other NOTIX
            personnel and/or employee to be deemed as information provided by
            NOTIX as part of the Provision of NOTIX Services to the User,
            whether conducted during the Provision of Services themselves and/or
            during the use of Self Service or Management Service, must be
            contacted through the authorised channels of NOTIX, namely through
            the support chat within SSP and through an email registered with
            NOTIX.  Any information provided through any other means of
            communication must not in any way be considered as information
            provided by NOTIX officers and/or support team and/or any other
            NOTIX personnel and/or employee as part of the Provision of NOTIX
            Services to the User and/or during the use of Self Service or
            Management Service.  NOTIX and User both consider all such other
            means of communication as unauthorised channels of communication and
            agree that NOTIX shall bear no responsibility whatsoever for any
            information provided through them.
          </span>
        </p>
        <p>
          <span>
            2.19. You may not transfer your account to anyone without explicit
            written permission of NOTIX and you may not use anyone else's
            account or password at any time without the express permission and
            consent of the holder of that account. NOTIX cannot and will not be
            liable for any loss or damage arising from your failure to comply
            with these obligations.
          </span>
        </p>
        <p>
          <span>
            2.20. NOTIX does not guarantee: (i) the placement, positioning or
            the timing of delivery of any Push Notification, or (ii) the number
            (if any) of subscribers.
          </span>
        </p>
        <p>
          <span>
            2.21. NOTIX reserves the right at any time to change the design of
            its Platform, website, application, Program, its Content, list of
            Services, modify or supplement the Scripts, software and other
            objects used or stored on the Platform/server at any time with or
            without prior notice. NOTIX has the right to send the User
            information about the development of the Platform/Program and its
            Services, as well as to advertise its own activities and Services.
          </span>
        </p>
        <p>
          <span>
            2.22. NOTIX reserves the right, for any reason whatsoever, at its
            own discretion and at any time, to modify, suspend, or discontinue
            the Services/Program (in whole or in part) with or without notice to
            you and without any further obligation to you whatsoever.  You agree
            that NOTIX will not be liable to you or to any third party for any
            modification, suspension, or discontinuation of the Services or any
            part thereof.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>3. Push Notifications </strong>
        </p>
        <p>
          <span>
            3.1. The User creates, manages, optimizes and sends Push
            Notifications to subscribers by choosing options provided by NOTIX
            through the Platform/Service.  Subscribers only receive Push
            Notifications created, managed and optimized by the User.
          </span>
        </p>
        <p>
          <span>
            3.2. The User bears full responsibility for the context of all Push
            Notifications created and/or sent to subscribers, which in turn must
            correspond to all relevant rules set by Anti-Spam
            laws/regulations/policies/rights. In any case the User is either in
            an alleged and/or actual breach of any relevant
            law/regulation/policy/right and/or of the obligations and
            restrictions of the User as those are described in clause 3.3.
            below, NOTIX may at its own discretion and without any prior notice,
            suspend and/or stop the Service and/or suspend/block the User's
            account for as long as necessary to investigate and/or ascertain the
            circumstances and/or immediately terminate this Agreement.
          </span>
        </p>
        <p>
          <span>
            3.3. User has a number of obligations and restrictions in relation
            to Push Notifications, including but not limited to the following:
          </span>
        </p>
        <ul>
          <li>
            <span>
              You must only send Push Notifications to such people who have
              expressed their consent to receiving such Push Notifications from
              you. The recipients' consent must be received by you personally.
              Upon NOTIX request you must provide corresponding proof of
              recipients' consent;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You must guarantee subscribers the ability to opt out of any
              further Push Notifications (e.g. through the presence of an
              unsubscribe link in the said communications) and you are obliged
              to un-subscribe and/or remove from the list contact details of
              subscribers/owners of data who have expressed their desire to opt
              out of Push Notifications;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You must clearly describe in writing how you plan to use any data
              collected, including for your use of the Service. You will get
              express consent to transfer data to NOTIX as part of this process,
              and you will otherwise comply with whatever privacy policy you
              have posted;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You hereby agree to comply at all times with all regulations, as
              well as data protection, electronic communication, and privacy
              laws that apply to the countries where you are sending any form of
              Push Notifications through the Service;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You must collect, store, use, and transfer all data relating to
              any individual in compliance with all data protection laws and
              regulations. You hereby confirm that you have all necessary
              permission to allow us to receive and process data and send Push
              Notifications to that individual on your behalf;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You hereby acknowledge and agree that the use of illegally or
              unlawfully obtained subscriber bases (
            </span>
            <span>including </span>
            <span>databases acquired without the consent of </span>
            <span>the</span>
            <span> </span>
            <span>subscriber)</span>
            <span>
               and distributing spam through NOTIX Service/Program is strictly
              prohibited.  NOTIX strictly forbids any SPAM messages to be sent
              from our Service at any time;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              Your Push Notifications must not include false, invalid or
              misleading information in the subject line or the body of the
              message and/or other prohibited content as described in clause 2
              and/or any other content which is prohibited by any and all
              relevant laws/regulations/policies worldwide;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              The text displayed in your Push Notifications must clearly state
              or illustrate the service that is offered, must clearly identify
              who is providing the service (originator) and clearly state the
              expense of the service promoted.
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You are forbidden to send web Push Notifications through API if
              the shared link domain differs from the sending one;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You are forbidden from sending out any information which violates
              a person's rights and freedoms.
            </span>
          </li>
        </ul>
        <p>
          <span>
            3.4. The time when Push Notifications are delivered to their
            recipients varies depending on a number of factors and
            circumstances. NOTIX shall not be liable for Push Notifications
            being undelivered to recipients, in equal measure, as well as any
            delays in delivery.  Push Notifications may go undelivered or be
            delayed for the following reasons:
          </span>
        </p>
        <ul>
          <li>
            <span>
              the subscriber's mobile phone is turned off or is outside the area
              of the mobile operator's coverage;
            </span>
          </li>
          <li>
            <span>
              due to adverse natural conditions or other force majeure
              circumstances, which might have an adverse effect on the operation
              of NOTIX's hardware and software. These conditions or
              circumstances include, but are not limited to, natural disasters,
              changes to law or regulations, embargoes, war, terrorist acts,
              riots, fires, earthquakes, nuclear accidents, floods, strikes,
              power blackouts, volcanic action, unusually severe weather
              conditions, and acts of hackers or third-party internet service
              providers.
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <p>
          <strong>4. Fees and User Account</strong>
        </p>
        <p>
          <span>
            4.1. Use of the Service shall be carried out on a monthly basis. For
            billing purposes a calendar month shall be deemed the month
            commencing from the date NOTIX Service becomes paid for a User and
            until the same date of the following month ("Reporting Period").{" "}
          </span>
        </p>
        <p>
          <span>
            4.2. During the Service User may track online reports/stats within
            NOTIX reporting system in Users' personal account, which are only
            estimated numbers subject to being adjusted within 15 days after the
            end of the Reporting Period. In all cases, we will use commercially
            reasonable methods and practices to calculate your subscribers,
            direct and measure traffic. At the end of the Reporting Period the
            reports are frozen and within 15 days will include the definitive
            numbers of earnings. For avoidance of doubt, NOTIX reporting system
            (stats) will be prevailing in any case.
          </span>
        </p>
        <p>
          <span>
            4.3. Cost of using Service depends on the amount of active
            subscribers collected in your account.  All reported statistics for
            the purposes of billing and general delivery reporting are based on
            NOTIX reporting system only.
          </span>
        </p>
        <p>
          <span>
            4.4. User acknowledges that the following pricing models may be
            offered, amongst others, by NOTIX:
          </span>
        </p>
        <ul>
          <li>
            <span>Free Plan: Up to thirty thousand subscribers (30,000).</span>
            <span> </span>
            <span>
              Unlimited number of push notifications. The Service is free of
              charge. All features are available.
            </span>
          </li>
          <li>
            <span>
              Basic Plan: From thirty thousand subscribers (30,000) and up to
              one hundred fifty thousand subscribers (150,000). Unlimited number
              of push notifications.
            </span>
            <span> All features are available.  </span>
            <span>Monthly pricing starts from</span>
            <span> </span>
            <span>thirty USD (30$).</span>
            <span> </span>
            <span>
               The cost of the User is one USD ($1) for each additional active
              subscriber.
            </span>
          </li>
          <li>
            <span>
              Monetization Plan: Unlimited number of subscribers and push
              notifications.  All features are available.  User generates
              revenue.  The Service is free of charge.  NOTIX Service provided
              to the User in relation to the Monetization Plan includes and/or
              relates only to the User's availability to apply and/or request
              for monetization, to the provision of credentials and to the
              mirror statistics.  The monetization service itself is provided by
              a third party to whom the User's request for monetization is
              transferred.  The User in order to receive the actual monetization
              service by the said third party must follow all procedures and
              take all actions necessary and/or requested by the said third
              party.  The User hereby understands and agrees that NOTIX is not
              in any way involved with the monetization service itself and/or in
              the procedures/requests of the third party.  The User hereby
              expressly releases and NOTIX rejects  any and all liability in
              relation to the User applying and/or using the monetisation
              service itself and/or in relation to the monetization service
              itself offered and/or provided by the third party.    
            </span>
          </li>
          <li>
            <span>
              Enterprise Plan: Unlimited number of subscribers and push
              notifications. All features are available.
            </span>
            <span>
                Custom terms and/or discounts may be negotiated and/or provided
              at the sole discretion of NOTIX.
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <p>
          <strong>5. Payments</strong>
        </p>
        <p>
          <span>
            5.1. NOTIX provides the ability to perform payments by using payment
            service providers. User shall have the right to select any payment
            service provider available. You agree that NOTIX is not responsible
            for any actions made by the payment service provider including but
            not limited to any additional transaction fees, banking commissions
            or currency fees applied to your transaction. All payments shall
            include the above-mentioned fees and commission, if applicable.
          </span>
        </p>
        <p>
          <span>
            5.2. User is responsible for all applicable taxes associated with
            provided Services, other than taxes based on NOTIX income. User
            shall indemnify NOTIX against all losses suffered or incurred by the
            NOTIX arising out of or in connection with any payment made to the
            User.
          </span>
        </p>
        <p>
          <span>
            5.3. User acknowledges and agrees that any credit card and related
            billing and payment information that User provides to NOTIX may be
            shared by NOTIX with companies who work on NOTIX' behalf such as
            payment processors and/or credit agencies solely for the purpose of
            checking credit and/or effecting payment to NOTIX and serving
            customers account.
          </span>
        </p>
        <p>
          <span>
            5.4. NOTIX shall not be liable for any use or disclosure of such
            information by such third Party.
          </span>
        </p>
        <p>
          <span>User acknowledges that:</span>
        </p>
        <ul>
          <li>
            <span>all executed transactions are final and non-refundable;</span>
          </li>
          <li>
            <span>
              notification of Buyer Errors must be reported by the User within
              24 hours;
            </span>
          </li>
        </ul>
        <p>
          <span>
            5.5. NOTIX reserves the right to discontinue Service at any time and
            terminate present Agreement without liability to User in case of
            material breach of this Agreement by the User or its associates.
            Parties hereby agree that any form of fraudulent or illegal
            activity, or any violation of the applicable laws and regulations,
            or any activity specified in clause 2 of this Agreement shall be
            deemed a material breach of this Agreement.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>6. Recurring Transaction</strong>
        </p>
        <p>
          <span>
            6.1. By filling Recurring Transaction Form and clicking the "I
            Agree" button you express full consent with these terms and
            conditions of recurring transactions and authorize NOTIX and payment
            service provider to automatically charge your credit card for
            recurring delivery of Services in agreed variable amount and
            variable date, stipulated in Recurring Transaction Form in your
            personal account.
          </span>
        </p>
        <p>
          <span>
            6.2. You acknowledge and agree that confirmation notification of the
            recurring transaction will be provided within 2 business days via
            email specified in your personal account.
          </span>
        </p>
        <p>
          <span>
            6.3. You certify that you are an authorized user of credit card,
            details provided in personal account of the Service, and that you
            will not dispute the scheduled payments with your credit card
            company provided the transactions correspond to the terms indicated
            in this Agreement.
          </span>
        </p>
        <p>
          <span>
            6.4. You agree to pay for all services or other additional services
            you ordered through NOTIX Service, as well as for any additional
            expenses (if necessary), including, but not limited, all possible
            taxes, charges, etc.
          </span>
        </p>
        <p>
          <span>
            6.5. You take full responsibility for timely payments for using the
            Service. Payment service provider only facilitates a payment for the
            amount indicated by NOTIX, and it is not responsible for paying by
            user of the Service the aforementioned additional funds/expenses.
          </span>
        </p>
        <p>
          <span>
            6.6. After clicking the "Pay" button the transaction is irrevocably
            deemed to be processed and executed. After clicking the "Pay" button
            you agree that you will not be eligible to cancel the payment or
            request to cancel it. By placing the order on the Service, you
            confirm and state that you do not violate legislation of any
            country. Also, by accepting this Agreement, you, as cardholder,
            confirm that you are entitled to use Service offered via NOTIX'
            website.
          </span>
        </p>
        <p>
          <span>
            6.7. By agreeing to use the Recurring Transaction Service, you
            understand and accept that processing of any of your payments are
            executed by the payment service provider, and there is no statutory
            right of revocation of already purchased services or any other
            opportunities to cancel the payment.
          </span>
        </p>
        <p>
          <span>
            6.8. You acknowledge that this Recurring Transaction Service will
            remain in effect until you cancel it, and you agree to notify NOTIX
            of any changes in your personal account information or cease of this
            Recurring Transaction Service at least 7 days prior to the next
            billing date. If you wish to reject to use Recurring Transaction
            services for your next purchases of services or other facilities on
            the NOTIX Service, you can do that by using email notification
            provided in contact details.
          </span>
        </p>
        <p>
          <span>
            6.9. When you pay for NOTIX Services, you are primarily bound by
            this Agreement. Please note that only you, as the cardholder, are
            responsible for paying for all services you have ordered through
            NOTIX Service and for any additional expenses/fees that can be
            applied to this payment. Payment service provider acts only as the
            executor of the payment in the amount stated by NOTIX, and it is not
            responsible for pricing, total prices and/or total sums.
          </span>
        </p>
        <p>
          <span>
            6.10. You acknowledge and agree that notification for following
            situations will be sent to you, using method of communication
            available, at least 7 business days prior: more than six month have
            elapsed since the last payment; or there are charges to the
            recurring transaction services including, but not limited to any
            change to the amount of the recurring transaction and/or any change
            to the date of the recurring transaction.
          </span>
        </p>
        <p>
          <span>
            6.11. In case there is a situation when you do not agree with the
            aforementioned terms and conditions of Recurring Transactions and/or
            other reasons, we ask you not to proceed with the payment, and, if
            necessary, contact directly support of NOTIX at{" "}
          </span>
          <span>
            <a href="mailto:support@notix.co">support@notix.co</a>
          </span>
          <span>.</span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>7. Representations, Warranties and Covenants</strong>
        </p>
        <ul>
          <li>
            <span>
              You acknowledge and represent, warrant and covenant that: NOTIX
              does not moderate your Push Notification in any way and that your
              Source(s),Push Notifications, Content are and must be at all times
              in compliance with all applicable and relevant laws/regulations,
              policies worldwide and with the terms and conditions of present
              Agreement, and that do not contain or promote, nor link to another
              Source(s)/websites/landing pages/links that contain, libelous,
              defamatory, abusive, violent, prejudicial, obscene, infringing,
              sexually explicit or illegal content, including copyright
              ownership infringements and unlawful use of intellectual property;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You agree not to promote via Source(s) and Push Notifications to
              Source(s)/websites/landing pages/links containing any
              pornographic, racial, ethnic, political, software pirating (e.g.
              Warez) or hacking, hate-mongering, or otherwise objectionable
              content;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You agree not to engage in any illegal activity, in accordance
              with applicable law, whatsoever, is not allowed;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You represent and warrant that you own or have legal rights to use
              and distribute all content, copyrighted material, trademarked
              materials, products, and services displayed on your Source(s) and
              Push Notifications;{" "}
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You agree not to use deceit when using the Service and/or through
              Push Notifications;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You have the right, power, and authority to enter into this
              Agreement and grant the rights specified herein;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You will not attempt in any way to alter, modify, eliminate,
              conceal, damage, detrimentally interfere with, misappropriate or
              otherwise render inoperable or ineffective the Program, software,
              database, tools, Script, ad tech, links, tags, source codes,
              links, pixels, modules, features or other data or Service provided
              by or obtained from NOTIX that allows NOTIX to measure subscribers
              and provide its Service ("Site Data");
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You will not use the Service, Program, tools, database, features,
              Script, etc, provided to you by NOTIX to create any software or
              service containing any malicious or harmful code nor in violation
              of any applicable law;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You will not circumvent or attempt to circumvent usage limits or
              use the Service, Program, tools,  database, features, Script
              provided to you by NOTIX at excessive levels that would degrade
              performance for other Users;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You shall not attempt to reverse engineer, de-compile, hack,
              disable, interfere with, disassemble, copy, or disrupt the
              integrity or the performance of the Services, any third-party use
              of the Services, or any third-party data contained therein (except
              to the extent such restrictions are prohibited by applicable law;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You shall not access the Services in order to build a competitive
              product or service or copy any ideas, features, functions, or
              graphics of the Services.  
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              If instructed to do so by NOTIX and/or if this Agreement
              terminates, you will immediately remove and discontinue the use of
              any Site Data;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You acknowledge that NOTIX does not represent, warrant, or make
              any specific or implied promises as to the successful use of
              Service;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You agree to display the Script exactly as it appears on the
              Program and will not alter it in any way;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              If you are notified that fraudulent activities may be occurring on
              your Source(s), and you do not take any actions to stop the
              fraudulent activities, then you are responsible for all associated
              costs and legal fees resulting in these fraudulent activities;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You represent, warrant and covenant that you will not take any
              action that imposes, or may impose, in our sole discretion, an
              unreasonable or disproportionately large load on our technology
              infrastructure or otherwise make excessive demands on it;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You may not disable, circumvent or otherwise interfere with
              security related features of our Service or features that prevent
              or restrict use or copying of any part of our Service, or which
              enforce limitations on the use of our Service;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              Hereby You irrevocably authorize NOTIX to transfer a request
              received by NOTIX to provide information for the payment directly
              to your financial institution available;
            </span>
          </li>
          <li>
            <span>
              You represent, warrant and covenant that your Source(s) does not
              contain any sexual or erotic material that depicts persons under
              the age of eighteen (18) or in a manner that suggests that they
              are under the age of eighteen (18);
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You shall not use the Script in conjunction with a Source that is
              directed to children under the age of 13. You shall not use the
              Script to knowingly send to NOTIX personal information (as defined
              under COPPA), including device identifiers or precise location
              data, that has been received from children under the age of 13;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              If any errors or undesirable results occur due to no fault of
              NOTIX, NOTIX shall not be responsible for losses;
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              User undertakes to ensure that its servers support the traffic
              directed through our Service. NOTIX takes no responsibility for
              all the consequences in the event your servers cannot support the
              traffic directed through our Service. You shall test your
              Source(s) to insure its correct appearance in different web
              browsers, devices or systems and optimize it if necessary.
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <ul>
          <li>
            <span>
              You acknowledge that every case of violation of the terms of this
              Agreement will lead to material and business standing losses of
              NOTIX in the amount of at least US $ 1,000. Therefore, we reserve
              the right to recover damages caused in the specified amount, or
              the amount of actually incurred losses, in the event of your
              breach of contract.{" "}
            </span>
          </li>
        </ul>
        <p>
          <span />
        </p>
        <p>
          <strong>8. Fraudulent Activity</strong>
        </p>
        <p>
          <span>
            8.1. YOU MAY NOT CHEAT, DEFRAUD OR MISLEAD US, OR ATTEMPT TO CHEAT,
            DEFRAUD OR MISLEAD US, IN ANY MANNER.
          </span>
        </p>
        <p>
          <span>
            You are expressly prohibited from using any means, Program, tools,
            Script, any part of the Services provided, devices or arrangements
            to commit fraud, violate any applicable law, interfere with other
            Users or falsify information in connection with the Services or
            exceed your permitted access to NOTIX Service.  
          </span>
        </p>
        <p>
          <span>
            These prohibited activities include but not limited to: framing an
            ad-banner's click-through destination, invisible iframe,
            auto-spawning of browsers, running "spiders"/"bots", and automatic
            redirecting of end users, and\or redirection of end user to the
            page\application with the pre-filled text\data.  In any case NOTIX
            shall make all determinations about fraudulent activity in its sole
            discretion.
          </span>
        </p>
        <p>
          <span>
            8.2. If User is suspected in any fraudulent activity NOTIX shall
            have the right to ban your User Account and to take all necessary
            legal actions to restore the damage caused by this violation.{" "}
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>9. End User Information</strong>
        </p>
        <p>
          <span>
            9.1. You acknowledge and agree that as part of the Services we will
            collect end users' personal data. You alone shall have sole
            responsibility for the accuracy, quality, integrity, legality,
            reliability, appropriateness, and intellectual property ownership or
            right to use of all personal data. You hereby grant (and you
            represent and warrant that you have the right to grant) to NOTIX a
            nonexclusive, royalty-free and fully paid, worldwide license (with
            the right to sublicense) to access, use, reproduce, electronically
            distribute, transmit, perform, format, display, store, archive, and
            index the end users' personal data for the purpose of supporting
            your use of the Services and providing the Services to you.{" "}
          </span>
        </p>
        <p>
          <span>
            9.2. NOTIX and the User shall jointly own other data, and each Party
            shall be entitled (without further compensation to the other) to
            use, share, market, license, sell, store, and otherwise exploit the
            other data to the maximum extent permitted by law and in any manner
            it deems appropriate.  Other data. "other data" means any and all
            information that is not personal data, including information derived
            from personal data that is (i) anonymized by removing any personal
            or other information so the data is in no way attributable to a
            specific customer or any individual; (ii) combined with the other
            data; and (iii) presented in a way which does not reveal the end
            user's identity.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>10. Limitation of Liability; Disclaimer of Warranty</strong>
        </p>
        <p>
          <span>
            10.1. IN NO EVENT SHALL NOTIX BE LIABLE FOR ANY DAMAGES OF ANY KIND
            ARISING FROM YOUR USE OF THE SERVICE, OPERATION OF A PROGRAM/TOOL,
            LICENCE FOR AND USE OF A SCRIPT OR YOUR DISPLAY OF ANY PROGRAM
            CREATIVE ON YOUR SOURCE(S), AND/OR FROM OUR EFFORT AND/OR OUR
            ACTIONS INTENTING TO INCREASE THE PERFORMANCE OF YOUR SOURCE(S)
            EITHER TAKEN WITH OR WITHOUT YOUR CONSENT INCLUDING BUT NOT LIMITED
            TO BROKEN IMAGES, SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE AND
            CONSEQUENTIAL DAMAGES, EVEN IF NOTIX HAS BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES. NOTIX IS ONLY THE TOOL ENABLING YOU TO
            SEND, OPTIMIZE AND MANAGE PUSH NOTIFICATIONS TO END USERS. THE
            SCRIPT, INFORMATION, PUSH NOTIFICATION SERVICES AND OTHER NOTIX
            SERVICES ARE PROVIDED ON AN "AS IS" BASIS WITH NO WARRANTY. YOU USE
            THE SERVICE, PLACE THE SCRIPT, CREATE/SEND/OPTIMIZE/MANAGE PUSH
            NOTIFICATIONS AND RUN PROGRAMS AT YOUR OWN RISK. TO THE MAXIMUM
            EXTENT PERMITTED BY LAW, NOTIX DISCLAIMS ALL REPRESENTATIONS AND
            WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, WITH RESPECT TO THE
            OPERATION AND USE OF THE SERVICE, THE LICENCE AND USE OF THE SCRIPT,
            THE INFORMATION, AND PUSH NOTIFICATIONS SERVICE INCLUDED ON THE
            SERVICE AND PROVIDED BY NOTIX, INCLUDING BUT NOT LIMITED TO IMPLIED
            WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
            NOTIX DOES NOT REPRESENT OR WARRANT THAT THE INFORMATION ON THIS
            SERVICE OR WEBSITE/PROGRAM OR OTHERWISE PROVIDED BY NOTIX IS
            ACCURATE, COMPLETE OR CURRENT.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>11. Indemnity</strong>
        </p>
        <p>
          <span>
            11.1. You shall indemnify, defend and hold NOTIX harmless from and
            against any and all claims, allegations, liabilities, costs and
            expenses (including reasonable attorneys´ fees) which may be
            incurred by or to the third parties arising out of your: (a)
            improper use of the Service; (b) improper operation of a
            Platform/Program/Tool; or (c) breach or violation of any clause of
            this Agreement or other mutual agreement of its parties.
          </span>
        </p>
        <p>
          <span>
            11.2. NOTIX shall have no obligation whatsoever to any User under
            this clause 9 to the extent such claim arises from: (a) use of the
            Script in a manner or for a purpose not specifically authorized
            under this Agreement; (b) any modification, change, amendment,
            customization, or adaptation of the Script not made wholly by NOTIX
            or any of its designees; (c) any modification, change, amendment,
            customization, or adaptation of the Script made by NOTIX at User's
            request; (d) User's failure to implement any corrections, updates,
            or changes to the Script provided by NOTIX; or (e) User's breach or
            alleged breach of its obligations under this Agreement. If User's
            use of the Script becomes (or is likely to become) the subject of a
            third-party infringement claim, NOTIX may, at its expense and
            option: (f) procure for User the right to continue to use the
            Script; (g) replace or modify the Script so that it becomes
            non-infringing; or (h) immediately terminate this Agreement.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>12. Assignment, Governing Law and Jurisdiction</strong>
        </p>
        <p>
          <span>
            12.1. NOTIX may assign this Agreement to a subsidiary or business
            successor. You may not assign this Agreement without the prior
            written consent of NOTIX, which shall not be unreasonably withheld.
          </span>
        </p>
        <p>
          <span>
            12.2. This Agreement and any dispute or claim (including
            non-contractual disputes or claims) arising out of or in connection
            with it or its subject matter or formation shall be governed by and
            construed in accordance with the law of Cyprus.
          </span>
        </p>
        <p>
          <span>
            12.3. Each party irrevocably agrees, for the sole benefit of NOTIX
            that, subject as provided below, the courts of Cyprus shall have
            exclusive jurisdiction over any dispute or claim (including
            non-contractual disputes or claims) arising out of or in connection
            with this Agreement or its subject matter or formation. Nothing in
            this clause shall limit the right of NOTIX to take proceedings
            against User in any other court of competent jurisdiction, nor shall
            the taking of proceedings in any one or more jurisdictions preclude
            the taking of proceedings in any other jurisdictions, whether
            concurrently or not, to the extent permitted by the law of such
            other jurisdiction.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>13. Severability</strong>
        </p>
        <p>
          <span>
            13.1. If any provision of this Agreement is held to be invalid,
            illegal or unenforceable for any reason, such invalidity, illegality
            or unenforceability shall not affect any other provisions of this
            Agreement, and this Agreement shall be construed as if such invalid,
            illegal or unenforceable provision had not been contained herein.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <span />
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>14. Intellectual Property Rights</strong>
        </p>
        <p>
          <span>
            14.1. Hereby we grant you a limited, worldwide, royalty-free,
            term-limited, non-exclusive, non-transferable, revocable license and
            right to access our website/Program/Platform/Script and/or to use
            the Service only in accordance with the terms and conditions of this
            Agreement.  You will only use NOTIX Script, database, features,
            Program and Service in connection with a Source owned and operated
            by you and you shall not sell, sublicense, give, rent, loan, lease,
            or otherwise make NOTIX Script, database, features, Program and
            Service or its components available to any third party without the
            NOTIX' s prior express written consent.
          </span>
        </p>
        <p>
          <span>
            14.2. You may not alter, modify, manipulate or create derivative
            works of NOTIX Script, database, features, Program and Service or
            any of our ad tech, graphics, creative, copy or other materials,
            tools owned by, or licensed to you by NOTIX in any way. We may
            revoke your license anytime by giving you written notice. Except as
            expressly stated herein, nothing in this Agreement is intended to
            grant you any rights to any of NOTIX trademarks, service marks,
            logos, domain names, copyrights, patents or other trade
            secrets/brand features.   You must not alter, hide, or remove any
            copyright, trademark, or other intellectual property rights
            contained in the NOTIX Script, database, features, Program and
            Service, nor reverse engineer, decompile, disassemble, or otherwise
            translate or derive the source code for NOTIX Script, database,
            features, Program and Service, or attempt to do so.  
          </span>
        </p>
        <p>
          <span>
            You acknowledge and agree that no intellectual property rights
            (including without limitation any rights based in trademark,
            copyright, patent or trade secret law) are or are intended to be
            transferred from NOTIX to you through this Agreement. You shall not
            receive, by virtue of this Agreement or performance under it any
            ownership interest in NOTIX's intellectual property. Without
            limitation of the above, NOTIX may use your name and logo solely in
            order to designate you as a User/licensee/client, for marketing
            purposes (e.g., on its website or email marketing materials).  You
            agree that we may use any suggestion, comment or recommendation you
            choose to provide to NOTIX without compensation. All rights not
            expressly granted in this Agreement are reserved by NOTIX.
          </span>
        </p>
        <p>
          <span>
            14.3. Your use of the Service shall be governed by and subject to
            the laws and regulations regarding copyright ownership and terms of
            use of intellectual property. You represent, warrant and covenant
            that you do not upload, download, display, perform, transmit, or
            otherwise distribute any object in violation of any third party's
            copyrights, trademarks, or other intellectual property rights. You
            represent, warrant and covenant that you abide by the laws regarding
            copyright ownership and use of intellectual property and you shall
            be solely responsible for any violations of any relevant laws and
            for any infringements of third party rights caused by you.
          </span>
        </p>
        <p>
          <span>
            14.4. ALL THE PARTIES HEREBY AGREE THAT NOTIX DOES NOT HAVE ANY
            AUTHORITY OR ABILITY TO CONTROL CONTENT AT USER'S SOURCE(S) AND/OR
            PUSH NOTIFICATIONS CREATED/SEND/OPTIMIZED/MANAGED BY USER AND FOR
            THIS REASON, WE CANNOT BEAR ANY RESPONSIBILITY REGARDING BREACHING
            OF ANY LAW/REGULATION OF ANY COUNTRY AND/OR ANY THIRD PARTY'S
            INTELLECTUAL PROPERTY RIGHTS AND/OR ANY OTHER RIGHTS OF ANY PERSON.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>15. Termination</strong>
        </p>
        <p>
          <span>
            15.1. This Agreement shall commence upon your acceptance and remain
            in effect until terminated. This Agreement may be terminated by
            either Party upon two (2) business days´written notice.  
          </span>
        </p>
        <p>
          <span>
            This Agreement shall terminate immediately upon the dissolution or
            insolvency of either Party, or the breach of this Agreement by you.{" "}
          </span>
        </p>
        <p>
          <span>
            NOTIX reserves the right, in its sole and absolute discretion, to
            terminate the Service/Program and remove any Script/Push
            Notifications at any time and for any reason, with no further
            obligations towards you.
          </span>
        </p>
        <p>
          <span>
            15.2. Upon termination of this Agreement, all license granted by
            NOTIX to the User for the execution of the Service under this
            Agreement shall immediately terminate and User shall no longer have
            any rights to use the Script in any way. User understands, however,
            that the collection of data through the Source(s) of the User on
            which the Script is already integrated, and the use of such data for
            purposes set forth herein, may continue until end users have (a)
            removed or disabled the Script (or any application that integrates
            the Script) from their respective devices, or any application that
            integrates the Script from your device, or (b) limited such data
            collection through applicable device settings in a manner that is
            communicated to NOTIX.
          </span>
        </p>
        <p>
          <span>
            15.3. This Agreement will be blocked when the User's Account has not
            been in use for more than three (3) months.
          </span>
        </p>
        <p>
          <span>
            You will receive a notification informing you that your account is
            blocked because of "Inactive account status". After deactivation,
            you will have 90 calendar days to restore your account. To do so,
            you have to login to your account and follow the steps described
            there. If your account is not reactivated within 90 calendar days it
            will be deleted without option to restore it.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>16. Force Majeure</strong>
        </p>
        <p>
          <span>
            16.1. Neither Party shall be liable to the other by reason of
            failure or delay in the performance of its obligations hereunder on
            account of Acts of God, fires, storms, war, governmental action,
            labor conditions, earthquakes, natural disasters, interruption in
            internet service or any other cause which is beyond the reasonable
            control of such Party. The party referring to such force majeure
            circumstances shall notify the other party on arising within 3
            working days from the date of its occurrence with the relevant
            evidence.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>17. Confidentiality</strong>
        </p>
        <p>
          <span>
            17.1. Each Party (a "Receiving Party") understands that the other
            Party (a "Disclosing Party") may disclose information of a
            confidential nature including, without limitation, product
            information, data, pricing, financial information, software,
            specifications, research and development and proprietary algorithms,
            stats and reports, personal data or other materials that is
            disclosed in a manner in which the Disclosing Party reasonably
            communicated, or the Receiving Party should reasonably have
            understood under the circumstances that the disclosure should be
            treated as confidential, whether or not the specific designation
            "confidential" or any similar designation is used ("Confidential
            Information").
          </span>
        </p>
        <p>
          <span>
            17.2. The Receiving Party agrees, for itself and its agents and
            employees, that it will not publish, disclose or otherwise divulge
            or use for its own purposes any Confidential Information of the
            Disclosing Party furnished to it by such Disclosing Party without
            the prior written approval of the Disclosing Party in each instance.
            Neither party will make any public announcement regarding the
            existence or content of the Agreement without the other's prior
            written approval.
          </span>
        </p>
        <p>
          <span>
            17.3. The Parties agree that if disclosure is made to their
            professional advisors, auditors or bankers this shall be done
            subject to each Party procuring each such recipient's agreement to
            keep such information confidential to the same extent as if such
            recipient were Party to this agreement.
          </span>
        </p>
        <p>
          <span>
            17.4. The foregoing obligations under this clause 15 shall not
            extend to any information to the extent that the Receiving Party can
            demonstrate that such information (i) was at the time of disclosure
            or, to the extent that such information thereafter becomes through
            no fault of the Receiving Party, a part of the public domain by
            publication or otherwise; (ii) was already properly and lawfully in
            the Receiving Party's possession at the time it was received by the
            Receiving Party free from any obligation of confidentiality, (iii)
            was or is lawfully received by the Receiving Party from a third
            Party who was under no obligation of confidentiality to the
            Disclosing Party with respect thereto, or (iv) is independently
            developed by the Receiving Party or its independent contractors who
            did not have access to the Disclosing Party's Confidential
            Information or (vi) express written consent has been given prior to
            disclosure.
          </span>
        </p>
        <p>
          <span>
            17.5. In the event that the Receiving Party is required to disclose
            Confidential Information in accordance with judicial or regulatory
            or governmental order or requirement, or any tax authority to which
            that Party is subject or submits, wherever situated, whether or not
            the requirement for information has the force of law the Receiving
            Party shall promptly notify the Disclosing Party in order to allow
            such Party to contest the order or requirement or seek confidential
            treatment for such information.
          </span>
        </p>
        <p>
          <span>
            17.6. Upon termination or expiration of this Agreement, upon the
            request of a Disclosing Party, the Receiving Party agrees to return
            to the other all of such other Party's Confidential Information, or
            to certify to the Disclosing Party in writing that all such material
            has been destroyed, however, destruction is only permitted after
            Disclosing Party's prior approval.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <strong>18. Miscellaneous</strong>
        </p>
        <p>
          <span>
            18.1. This Agreement contains the sole and entire agreement and
            understanding between the Parties relating to the subject matter
            herein, and merges all prior discussions, whether through officers,
            directors, salespersons, employees or consultants.
          </span>
        </p>
        <p>
          <span>
            18.2. Present Agreement is the principal document in legal
            relationship of the Parties, and shall be deemed an entire agreement
            of the Parties. In case of contradictions in using Service or
            Program, present Agreement shall prevail in any case.
          </span>
        </p>
        <p>
          <span>
            18.3. Each Party is an independent contractor and not a partner,
            joint venture or employee of the other. All notices shall be sent to
            the addresses submitted by you when signing up for the Service by
            certified mail, fax, email or courier.
          </span>
        </p>
        <p>
          <span>
            18.4. User understands and agrees that NOTIX may update/amend and/or
            change and/or terminate/stop any program/Service/Push Notification,
            in any way and for any reason at its own discretion, with a prior
            twenty four (24) hours' notice to the User, except in cases which
            are considered as of emergency/urgency by NOTIX and subject to
            clause 13.1 hereof, where any and all such updates/amendments and/or
            changes and/or terminations/stops will take place immediately and at
            the same time with a notification to be sent to the User via email
            or through his/her/its personal account.
          </span>
        </p>
        <p>
          <span>
            18.5. NOTIX reserves the right to change any terms and conditions of
            this Agreement at any time. You may refer to contract revisions in
            our website – <a href="http://www.notix.co"> www.notix.co</a> . The
            terms and conditions of present Service and License Agreement (as
            published on <a href="http://www.notix.co"> www.notix.co</a> /terms
            (the "Terms") bind the parties from the date signed or the date
            service is provided and shall apply to each and any services
            provided by NOTIX. This Agreement shall take precedence over any
            other terms and conditions issued or stated or referenced to apply
            relating to the Services provided by NOTIX.
          </span>
        </p>
        <p>
          <span>
            18.6. Representations and warranties of User set forth in this
            Agreement (in particular, clause 5) hereof shall survive closing for
            a period of one (1) year from the termination date.
          </span>
        </p>
        <p>
          <span>
            18.7. No claim for a breach of any representation or warranty by
            NOTIX shall be actionable or payable if the breach in question
            results from or is based on a condition, state of facts or other
            matter which was disclosed to User and/or actually known by User
            prior to termination.
          </span>
        </p>
        <p>
          <span>
            18.8. User acknowledges and agrees that entering into this Agreement
            it has not relied and is not relying on any representations,
            warranties or other statements whatsoever, whether written or oral
            other than those expressly set out in this Agreement, Privacy Policy
            or other terms and conditions published at{" "}
            <a href="http://www.notix.co"> www.notix.co</a> and that it will not
            have any right or remedy rising out of any representation, warranty
            or other statement not expressly set out in this Agreement.
          </span>
        </p>
        <p>
          <span>
            18.9. All claims related to the use of the Service or Program shall
            be submitted by the User within 30 days from the end of the
            Reporting Period only. In the case of missing the specified term,
            NOTIX reserves the right not to process the complaint, and all the
            services shall be deemed rendered properly.
          </span>
        </p>
        <p>
          <span>
            18.10. Headings to sections and subsections in this Agreement are
            for the convenience of the parties only and are not intended to be a
            part of or affect the meaning or interpretation hereof.
          </span>
        </p>
        <p>
          <span>
            18.11. You agree on using of any communication method (email
            message/SMS message/phone) with contact details provided in your
            personal account.
          </span>
        </p>
        <p>
          <span />
        </p>
        <p>
          <span>This agreement was last updated on </span>
          <span>26.07.2021</span>
        </p>
      </div>
    </div>
  );
}
